<template>
  <v-container>
    <h1>Téléchargements</h1>
    <h2>Obtention de fiches de dispositifs médicaux et liste des produits</h2>
    Recherchez puis sélectionnez le ou les produits dont vous souhaitez
    télécharger les fiches de dispositif médical
    <v-subheader
      v-if="produitsChoisis.length > 0"
      :class="efficencyTextColor"
      class="flex-row-reverse mt-2 pb-0 text-right"
    >
      {{ produitsChoisis.length }} DM choisi{{
        produitsChoisis.length > 1 ? "s" : ""
      }}
    </v-subheader>
    <v-autocomplete
      class="mt-0 pt-0"
      v-model="produitsChoisis"
      :items="produits"
      small-chips
      multiple
      color="blue-grey lighten-2"
      label=""
      item-text="denominationCommerciale"
      item-value="id"
      :search-input.sync="searchInput"
      @input="searchInput = null"
    >
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.select"
          @click:close="remove(data.item)"
        >
          {{ data.item.denominationCommerciale }}
        </v-chip>
      </template>
      <template v-slot:append-outer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="warning"
              dark
              v-bind="attrs"
              v-on="on"
              @click="removeAll"
            >
              mdi-checkbox-multiple-blank
            </v-icon>
          </template>
          <span>Désélectionner tout</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              @click="selectAll"
            >
              mdi-checkbox-multiple-marked
            </v-icon>
          </template>
          <span>Sélectionner tout</span>
        </v-tooltip>
      </template>
    </v-autocomplete>
    <v-row>
      <v-col
        ><v-btn
          color="produit"
          text
          :disabled="produitsChoisis.length == 0"
          :loading="isLoadingPdf"
          @click="getFiches"
          ><v-icon>mdi-download</v-icon> Télécharger les fiches</v-btn
        ></v-col
      ><v-col
        ><v-btn
          color="produit"
          text
          @click="getRefTableAsCsv('produits')"
          :loading="isLoadingCsv"
          ><v-icon>mdi-file</v-icon> Obtenir le fichier CSV des produits</v-btn
        ></v-col
      >
    </v-row>
    <v-row>
      <v-col>
        <h2>Téléchargements des tables de références (fichiers CSV)</h2>
        <v-list>
          <v-list-item-group color="primary">
            <v-list-item
              v-for="(refTable, i) in referenceTables"
              :key="i"
              @click="getRefTableAsCsv(refTable.kind)"
            >
              <v-list-item-icon>
                <v-icon v-text="refTable.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="refTable.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FournisseurService from "@/services/FournisseurService";

export default {
  data() {
    return {
      produitsChoisis: [],
      produits: [],
      isLoadingCsv: false,
      isLoadingPdf: false,
      searchInput: null,
      referenceTables: [
        {
          icon: "mdi-tag",
          text: "Dénominations communes (2.1)",
          kind: "denos",
        },
        {
          icon: "mdi-package",
          text: "Conditionnements des références (2.7)",
          kind: "conditionnements",
        },
        // {
        //   icon: "mdi-move-resize",
        //   text: "Caractéristiques des références (2.7)",
        //   kind: "caracteristiques",
        // },
        {
          icon: "mdi-video-input-component",
          text: "Eléments constitutifs (2.8)",
          kind: "elements",
        },
        {
          icon: "mdi-palette-swatch-variant",
          text: "Matériaux des éléments constitutifs (2.8)",
          kind: "materiaux",
        },
        {
          icon: "mdi-cup-water",
          text: "Substances actives (2.8)",
          kind: "substances",
        },
        // { icon: "mdi-focus-field", text: "Domaines (2.9)", kind: "domaines" },
        {
          icon: "mdi-fire",
          text: "Procédés de stérilisations (3)",
          kind: "sterilisations",
        },
      ],
    };
  },
  computed: {
    efficencyTextColor() {
      return `${this.efficencyColor}--text`;
    },
    efficencyColor() {
      if (this.produitsChoisis.length < 10) {
        return "green";
      } else if (this.produitsChoisis.length < 25) {
        return "yellow";
      } else if (this.produitsChoisis.length < 50) {
        return "orange";
      } else {
        return "error";
      }
    },
  },
  methods: {
    selectAll() {
      this.produits.forEach((item) => {
        if (
          !this.produitsChoisis.includes(item) &&
          item.denominationCommerciale
            .toLowerCase()
            .indexOf(this.searchInput.toLowerCase()) !== -1
        ) {
          this.produitsChoisis.push(item);
        }
      });
    },
    removeAll() {
      this.produitsChoisis = [];
    },
    remove(item) {
      const index = this.produitsChoisis.indexOf(item.id);
      if (index >= 0) this.produitsChoisis.splice(index, 1);
    },
    getFiches() {
      if (this.isLoadingCsv || this.isLoadingPdf) return;
      this.isLoadingPdf = true;
      FournisseurService.getFichesDM(this.produitsChoisis)
        .then((response) => {
          let blob = new Blob([response.data], {
            type:
              this.produitsChoisis.length == 1
                ? "application/pdf"
                : "application/zip",
          });
          let url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .catch((err) => {
          // console.log("In promise error handler");
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          this.isLoadingPdf = false;
        });
    },
    // getCsv() {
    //   if (this.isLoadingCsv || this.isLoadingPdf) return;
    //   this.isLoadingCsv = true;
    //   const SEP_LIGNES = "\n";
    //   const SEP_COLS = ";";
    //   let url = process.env.VUE_APP_CONSULT_URL;
    //   let data = this.produits.map((item) => {
    //     let itemUrl = `${url}/fiche-produit/${item.id}`;
    //     let text = `${item.id}${SEP_COLS}"${item.denominationCommerciale}"${SEP_COLS}${itemUrl}`;
    //     return text;
    //   });
    //   // console.log(data);
    //   let header = `ID${SEP_COLS}Dénomination commerciale${SEP_COLS}URL${SEP_LIGNES}`;

    //   let csv = header + data.join(SEP_LIGNES);
    //   const anchor = document.createElement("a");
    //   const universalBOM = "\uFEFF";
    //   anchor.href =
    //     "data:text/csv;charset=utf-8," + encodeURIComponent(universalBOM + csv);
    //   anchor.target = "_blank";
    //   anchor.download = "produits.csv";
    //   anchor.click();
    //   this.isLoadingCsv = false;
    // },
    getRefTableAsCsv(kind) {
      if (this.isLoadingCsv || this.isLoadingPdf) return;
      this.isLoadingCsv = true;
      const SEP_LIGNES = "\n";
      const SEP_COLS = ";";
      const universalBOM = "\uFEFF";
      let distantMethod = null;
      let url = process.env.VUE_APP_CONSULT_URL;

      switch (kind) {
        case "produits":
          distantMethod = FournisseurService.getProduitsPourCsv();
          break;
        case "denos":
          distantMethod = FournisseurService.getDenominations({ all: true });
          break;
        // case "caracteristiques":
        //   distantMethod = FournisseurService.getCaracteristiques({ all: true });
        //   break;
        case "conditionnements":
          distantMethod = FournisseurService.getConditionnements({ all: true });
          break;
        // case "domaines":
        //   distantMethod = FournisseurService.getDomaines({ all: true });
        //   break;
        case "elements":
          distantMethod = FournisseurService.getElements({ all: true });
          break;
        case "materiaux":
          distantMethod = FournisseurService.getMateriaux({ all: true });
          break;
        case "sterilisations":
          distantMethod = FournisseurService.getSterilisations({ all: true });
          break;
        case "substances":
          distantMethod = FournisseurService.getSubstances({ all: true });
          break;
        default:
          distantMethod = FournisseurService.getDomaines({ all: true });
      }
      distantMethod
        .then((response) => {
          let data = response.data.map((item) => {
            let text = `${item.id}${SEP_COLS}"${item.libelle}"`;
            if (kind == "denos") {
              text += `${SEP_COLS}"${
                item.definition.replace(/"/g, '""') || ""
              }"${SEP_COLS}"${item.typologie || ""}"${SEP_COLS}"${
                item.domaines
              }"${SEP_COLS}"${item.equivalences}"`;
            } else if (kind == "produits") {
              let itemUrl = `${url}/dispositif-medical/${item.id}`;
              text = `${
                item.id
              }${SEP_COLS}"${item.denominationCommerciale.replace(
                /"/g,
                '""'
              )}"${SEP_COLS}"${item.denominationCommune}"${SEP_COLS}"${
                item.domaines
              }"${SEP_COLS}${itemUrl}`;
            }
            return text;
          });
          // console.log(data);
          let header = `ID${SEP_COLS}Libellé`;
          if (kind == "denos") {
            header += `${SEP_COLS}Définition${SEP_COLS}Typologie${SEP_COLS}Domaines${SEP_COLS}Equivalences`;
          } else if (kind == "produits") {
            header = `ID${SEP_COLS}Dénomination commerciale${SEP_COLS}Dénomination commune${SEP_COLS}Domaines${SEP_COLS}URL`;
          }
          header += SEP_LIGNES;
          let csv = header + data.join(SEP_LIGNES);
          const anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," +
            encodeURIComponent(universalBOM + csv);
          anchor.target = "_blank";
          anchor.download = `${kind}.csv`;
          anchor.click();
          this.isLoadingCsv = false;
        })
        .catch((err) => {
          // console.log("In promise error handler");
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          this.isLoadingCsv = false;
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    FournisseurService.getProduitsPublies()
      .then((res) => {
        next((vm) => {
          vm.produits = res.data;
          vm.$store.dispatch("stopLoading");
        });
      })
      .catch((err) => {
        // console.log("In promise error handler");
        if (err.response && err.response.status && err.response.status == 401) {
          next({ name: "home" });
        } else if (err instanceof Error) {
          // console.log("About to call next(err)");
          let errorToPropagate = new Error();
          errorToPropagate.originalError = err;
          next(errorToPropagate);
        }
      });
  },
};
</script>

<style></style>
